import { useSelector } from "react-redux";
import { getSearchResultsFlightOffers } from "../store/searchResults/selectors";

const useSearchResultOffer = (offerToken: string) => {
  const searchResultsFlightOffers = useSelector(getSearchResultsFlightOffers);
  const flightOffer =
    searchResultsFlightOffers.length && searchResultsFlightOffers.find((offer) => offer.token === offerToken);
  return flightOffer;
};

const usePrefetchedBrandedFaresOffer = (offerToken: string) => {
  const searchResultsFlightOffers = useSelector(getSearchResultsFlightOffers);
  const flightOffer =
    searchResultsFlightOffers.length &&
    searchResultsFlightOffers.find((offer) =>
      offer?.brandedFareOffers?.find((brandedFareOffer) => brandedFareOffer.token === offerToken)
    );
  return flightOffer;
};

export { useSearchResultOffer, usePrefetchedBrandedFaresOffer };
